var slideOptions = require('../slide/slide-options'),
	slideClick = function() {
		if (document.querySelectorAll('.coto_slide-toggle')) {
			var $slideToggle = document.querySelectorAll('.coto_slide-toggle');

			for (let $toggle of $slideToggle) {
				var $mobileAccordian = $toggle.classList.contains('mobile-accordian');

				$toggle.querySelector('.coto_toggle-button').addEventListener('click', function() {
					
					if ($mobileAccordian) {
						if (document.documentElement.clientWidth <= 768) {
							$toggle.classList.toggle('coto_open');
							slideOptions.slideToggle($toggle.querySelector('.coto_slide-dropdown'));
						}
					} else {
						$toggle.classList.toggle('coto_open');
						slideOptions.slideToggle($toggle.querySelector('.coto_slide-dropdown'));
					}
				});

				if ($toggle.querySelector('.coto_stop-prop')) {
					$toggle.querySelector('.coto_stop-prop').addEventListener('click', function(event) {
						event.stopPropagation();
					});
				}

				if ($mobileAccordian) {
					window.addEventListener('resize', function() {
						if (document.documentElement.clientWidth > 768) {
							$toggle.classList.remove('coto_open');
							$toggle.querySelector('.coto_slide-dropdown').removeAttribute('style');
						}
					});
				}
			}
		}
	};

module.exports = slideClick;